module.exports = __webpack_public_path__ + "img/V0.f79d083d.jpg";